export const getNumberInputValue = (value, defaultValue) => {
  let inputValue = value ?? defaultValue ?? ''

  return ['string', 'number'].includes(typeof inputValue) ? inputValue : ''
}
